<style>

.card{
  position: relative;
  color: white;
}

img{
  object-fit: cover;
  width: 100%;
}
.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.6);
}
.stars{
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.6);
}
.info{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 5px;
  background-color: rgba(0,0,0,0.6);
}
.name{
  font-size: 21px;
}

.user-info{
  margin: 20px;
}

.distance{
  font-style: italic;
}
.about-me{
  font-family: Sansation;
  font-size: 24px;
  font-style: italic;
  margin: 15px 10px;
}
.bio{
  margin: 10px;
}
.common-interests{
  font-family: Sansation;
  font-size: 24px;
  font-style: italic;
  margin: 35px 10px 15px 10px;
}

.common-interests-headline{
  font-weight: 500;
  font-style: italic;
  text-align: center;
}
.match-score{
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}
.view-all{
  font-size: 14px;
  font-style: italic;
  text-align: center;
}

.sub-item{
  height: 150px;
  text-align: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  border-radius: 11px;
  border: 1px black solid;
  margin: 0 5px 20px 14px;
}
.sub-item-text{
  margin-top: 58px;
  font-size: 26px;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0,0,0,1);
}

.question{
  margin: 28px;
}
.question-answer{
  margin: 0 0 0 9px;
}
.question-slider{
  margin: 10px 16px;
}

.me, .them{
  display: inline-block;
  height: 15px;
  width: 15px;
  border-radius: 20px;
  background-color: #00d1ff;
}
.them{
  background-color: #fff500;
}

.my-interests{
  font-family: Sansation;
  font-size: 24px;
  font-style: italic;
  margin: 20px;
}
.my-interests-text{
  margin: 20px;
}

.message-friends-buttons{
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 20px 0;
}
.message{
  grid-column: 1;
  grid-row: 1;
  padding: 0 10px;
}
.friends{
  grid-column: 2;
  grid-row: 1;
  padding: 0 10px;
  text-align: right;
}
.coming-soon{
  grid-row: 2;
  grid-column-start: 1;
  grid-column-end: 3;
  text-align: center;
  font-size: 12px;
  color: gray;
}

button{
  border-radius: 15px;
  border-width: 1px;
  padding: 10px 20px;
}
.photos{
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.a-photo{
  width: 100px;
  height: 100px;
  background-image: url('/i/horse_backriding.jpg');
  background-color: gray;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  margin: 5px;
}

.friend-buttons{
  margin-bottom: 10px;
}
button.edit{
  border-radius: 5px;
  border-width: 1px;
  padding: 10px 20px;
  background-color: rgba(255,255,255,0.6);
  border: 1px gray solid;
  color: black;
}
button.edit:hover{
  background-color: white;
}

.no-events{
  margin: 10px;
}
</style>

<Auth bind:this="{auth}"></Auth>


<Header 
back="{true}"
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }, ] }"
on:addEvent="{ () => push('/edit-event/new') }"
on:back="{ () => { pop() } }">Friend Profile</Header>
<div class="has-header"></div>

<div class="card">
  {#if photo != ""}
    <img src="https://routes.hot0.workers.dev/fi/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{fuid}/{photo}" alt="" class="img">
  {/if}
</div>

<div class="user-info">
  <div class="name"><strong>{name}</strong> {age}</div>
  <div class="distance">{distance} miles away</div>
</div>

<div class="message-friends-buttons">
  <div class="message"><button on:click="{ () => push('/message/'+params.oid) }" disabled>Message</button></div>
  <div class="friends"><button on:click="{ () => editFriendStatus = true }" disabled><i class="icon-check"></i> Friends</button></div>
  <div class="coming-soon">messaging coming soon...</div>
</div>

<div class="common-interests-headline">Match Percentage</div>
<div class="match-score">{matchScore}%</div>
<VennMatch match="{matchScore}"></VennMatch>
<!-- <div class="view-all">tap to view all</div> -->

<div class="about-me">About Me</div>
<div class="bio">{bio}</div>

<div class="common-interests">Common Interests</div>
{#each commonInterests as item}
  <div class="sub-item" style="background-image: url('/categories/{item.p}.jpg');">
    <div class="sub-item-text">{item.t}</div>
  </div>
{/each}

<div class="common-interests">Match Questions</div>
{#each questions as item, index}

  <div class="question">Q: {Questions[index].question}</div>
  <div class="question-answer"><div class="me"></div> Me: <strong>{ item.me != 0 ? Questions[index].answers[ item.me - 1 ] : 'No Answer' }</strong></div>
  <div class="question-answer"><div class="them"></div> Them: <strong>{ item.them != 0 ? Questions[index].answers[ item.them - 1 ] : 'No Answer' }</strong></div>
  <div class="question-slider">
    <MatchSlider me="{item.me}" them="{item.them}"></MatchSlider>
  </div>
  
{/each}


<!-- <div class="common-interests">{name}'s Photos</div>
<div class="photos">
  <div class="a-photo"></div>
  <div class="a-photo"></div>
  <div class="a-photo"></div>
</div> -->

<div class="common-interests">{name}'s Upcoming Events:</div>

{#if events.length}

  {#each events as item}

  <div class="card" on:click="{ () => { push('/events-info/'+item.eid) } }">
    <img src="https://routes.hot0.workers.dev/ei/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{item.eid}/{item.photoIds[0]}" alt="event" class="img">
    <div class="starts-in"><StartsIn currentTime="{currentTime}" start="{item.start}" end="{item.end}"></StartsIn></div>
    
    <div class="stars"><Stars stars="{item.stars}"></Stars></div>
    
    <div class="info">
      <div class="name">{item.ename}</div>
      <div><EventTime start="{item.start}" end="{item.end}"></EventTime></div>
    </div>
  </div>

  {/each}

{:else}
  
  <div class="no-events">No upcoming events right now</div>
  
{/if}


<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Auth from "../interfaces/Auth.svelte";
let auth;

import {getBoundsFromLatLong, calcDistance} from "../helpers/Geo.js";
import {matchMeWith} from "../helpers/Match.js";
import ShareCrypto from "../helpers/ShareCrypto.js";
import DateTime from "../helpers/DateTime.js";
import tinterests from "../helpers/InterestCategories.js";
import Questions from "../helpers/Questions.js";
import Xss from "../helpers/Xss.js";

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import Stars from "../components/Stars.svelte";
import EventTime from "../components/EventTime.svelte";
import StartsIn from "../components/StartsIn.svelte";
import Dialog from "../components/DialogSlide.svelte";
import DialogPopup from "../components/Dialog.svelte";
import VennMatch from "../components/VennMatch.svelte";
import MatchSlider from "../components/MatchSlider.svelte";

let fuid = "";
let photo = "";
let name = "";
let age = 0;
let matchScore = 0;
let distance = 0;
let bio = "";
let commonInterests = [];
let questions = [];
let me = null;

let allInterests = [];

let interval = null;
let currentTime =  Math.round( Date.now() / 1000 );
let events = [];

import { onMount } from "svelte";
onMount(async () => {
  
  interval = setInterval( () => { currentTime =  Math.round( Date.now() / 1000 ) }, 1000 * 60 * 1);
  
  me = localStorage.getItem("store");
  me = JSON.parse(me);
  
  allInterests = tinterests.convert();
  
  let {matchScore, them} = await friendLoadProfile(params.fuid);
  console.log("matchScore:", matchScore);
  showProfile(matchScore, them);
});


async function friendLoadProfile(fuid) {
  // load friend
  let friend = await auth.post("friendLoadProfile", {fuid: fuid});
  friend = JSON.parse(friend);
  events = friend.events;
  friend = ShareCrypto.decrypt(friend);
  
  // need to filter any incoming data, because the server can not filter xss in encrypted data.  the clients will filter before saving, but if there is a nefarious client out there, they might be able to inject xss, bypassing any client side filtering
  friend = Xss.filter(friend);
  // console.log("friend:", friend);
  
  let them = JSON.parse( friend );
  them.events = events;
  // console.log("them:", them);
  // console.log("me:", me);
  
  let tMatchScore = matchMeWith(me, them, 50, DateTime.mysqlDateNow() );
  
  // console.log("----MatchScore:", tMatchScore);
  
  return {matchScore: tMatchScore, them: them};
}


async function showProfile(tMatchScore, them) {
  // load profile
  fuid = them.uid;
  photo = them.photoIds[0];
  name = them.name;
  age = DateTime.getAge(them.birthday);
  matchScore = tMatchScore;
  bio = them.bio;
  events = them.events;
  
  distance = calcDistance(me, them, true);
  
  let interestIds = []
  for (let i in me.interests) {
    if (them.interests.includes( me.interests[i] ) == true ) {
      interestIds.push(me.interests[i]);
    }
  }
  
  // console.log("interestIds:", interestIds);

  commonInterests = [];
  
  // loop through allInterests and pull out the image filename
  for (let i in allInterests) {
    if (allInterests[i].h == 1 && interestIds.includes(allInterests[i].i) == true) {
      commonInterests.push( {p: allInterests[i].p/* photo */, t: allInterests[i].t/* text */} );
    }
  }
  // console.log("commonInterests:", commonInterests);
  
  questions = [];
  for (let i in me.questions) {
    questions.push({me: me.questions[i], them: them.questions[i]})
  }
  
  // console.log("questions:", questions);
  
}

</script>